import fetchDataFromSpreadsheet from "./getCompanyDataFromGoogleSheets";

async function fetchSpreadsheetData() {
  const rows = await fetchDataFromSpreadsheet();

  const companyNamesSet = new Set();
  const companyCountriesSet = new Set();
  const sectorsSet = new Set();

  rows.map((row) => {
    companyNamesSet.add(row['Name']?.trim());
    companyCountriesSet.add(row['Country']?.trim());
    sectorsSet.add(row['Sector']?.trim());
  });

  // Convert sets to arrays
  const companyNames = Array.from(companyNamesSet);
  const companyCountries = Array.from(companyCountriesSet);
  const sectors = Array.from(sectorsSet);

  return { companyNames, companyCountries, sectors };
}
export default fetchSpreadsheetData;
